export default {
  help: {
    id: 'header_to_help',
    defaultMessage: 'Help',
  },
}
